import React from 'react'
import { InputNumerText, ComboNormal, Tr } from '../components'

const Tutor = ({ values, setValues, generos }) => {
  return (
    <>
 <Tr
                cols={"5"}
                title="Datos del encargado"
                dist={[3,1,1]}
                gap="2"
                children={[
                  <InputNumerText enabled={true}  label={"Nombre"} name={"NombreCompletoEncargado"} values={values} setValue={setValues} type="text" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
                  <ComboNormal    disabled={true} label={"Genero"} name={"GeneroEncargado"} values={generos} /*setComboValue={setValues}*/ id="id" text="nombre" defaultValue={values.GeneroEncargado} fakeValue="" tryToSave="" required={values.Nombre1 ? false : true}/*handleBlur={existeLoginId}*/></ComboNormal>,
                  <InputNumerText enabled={true}  label={"Edad"}   name={"E_Edad"} values={values} setValue={setValues} type="text" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
                  ]}
                    >
                </Tr>
                <Tr
                  cols={"5"}
                  dist={[5]}
                  gap="2"
                  children={[
                    <InputNumerText enabled={true}  label={"Dirección"} name={"E_Direcc"} values={values} setValue={setValues} type="text" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
                  ]}
                  >
                </Tr>
                <Tr
                   cols={"5"}
                   gap={"2"}
                   children={[
                     <InputNumerText enabled={true}  label={"Teléfono casa"} name={"E_TelCasa"} values={values} setValue={setValues} type="tel" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
                     <InputNumerText enabled={true}  label={"Teléfono trabajo"} name={"E_TelTrab"} values={values} setValue={setValues} type="tel" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
                     <InputNumerText enabled={true}  label={"Teléfono Móvil 1"} name={"Movil1"} values={values} setValue={setValues} type="tel" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
                     <InputNumerText enabled={true}  label={"Teléfono Móvil 2"} name={"Movil2"} values={values} setValue={setValues} type="tel" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
                     <InputNumerText enabled={true}  label={"Teléfono Móvil 3"} name={"Movil3"} values={values} setValue={setValues} type="tel" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
                    ]}
                >
                </Tr>,
                <Tr
                   cols={"4"}
                   gap={"2"}
                   dist={[1,1,1,1]}
                   children={[
                     <InputNumerText enabled={true}  label={"Celular #1 envío SMS"} name={"E_Cel"} values={values} setValue={setValues} type="tel" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
                     <InputNumerText enabled={true}  label={"Celular #2 envío SMS"} name={"E_Cel2"} values={values} setValue={setValues} type="tel" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
                     <InputNumerText enabled={true}  label={"Email #1"} name={"E_Mail"} values={values} setValue={setValues} type="email" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,
                     <InputNumerText enabled={true}  label={"Email #2"} name={"EmailT"} values={values} setValue={setValues} type="email" required={values.Nombre1 ? false : true}/*tryToSave={tryToSave}*//*handleBlur={existeLoginId}*/></InputNumerText>,     
                    ]}
                    >
                </Tr>
    </>
  )
}

export default Tutor